//  示例
import http from '@/utils/http';

export const Dict = {
    url: "/api/adhd/v2/scaleOwnership",
    list: function (params) {
        return http({
            url: Dict.url + '/list',
            method: "get",
            params
        })
    },
    add: function (data) {
        return http({
            url: Dict.url,
            method: "post",
            data
        })
    },
    del: function (id) {
        return http({
            url: Dict.url + '?' + `id=${id}`,
            method: "delete",

        })
    },
    edit: function (data) {
        return http({
            url: Dict.url,
            method: "put",
            data
        })
    },
}

// 每一题
export const scale = {
    url: "/api/adhd/v2/scale",
    list: function (params) {
        return http({
            url: scale.url + '/list',
            method: "get",
            params
        })
    },
    add: function (data) {
        return http({
            url: scale.url,
            method: "post",
            data
        })
    },
    del: function (id) {
        return http({
            url: scale.url + '?' + `id=${id}`,
            method: "delete",

        })
    },
    edit: function (data) {
        return http({
            url: scale.url,
            method: "put",
            data
        })
    },
}
// 新增量表简介
export const ScaleIntroduction = {
    url: "/api/adhd/v2/adhdScaleIntroduction",
    list: function (params) {
        return http({
            url: scale.url + '/list',
            method: "get",
            params
        })
    },
    add: function (data) {
        return http({
            url: scale.url,
            method: "post",
            data
        })
    },
    del: function (id) {
        return http({
            url: scale.url + '?' + `id=${id}`,
            method: "delete",

        })
    },
    edit: function (data) {
        return http({
            url: scale.url,
            method: "put",
            data
        })
    },
} 